let title = ' | Gestor - Comercial Ivaiporã'

const normativa = {
    path: '/normativa',
    props: true,
    component: () => import('@/Components/Normativa/NormativaContainer.vue'),
    children: [
        {
            path: '',
            name: 'NormativaLista',
            component: () => import('@/Components/Normativa/Normativas/NormativaLista.vue'),
            meta: {
                title: 'Normativas' + title,
                permission: 'normativa',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Normativas',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '',
                    }
                ]
            }
        },
    ]
}

export default normativa